import cn from "clsx";
import IntlPopover from "./popover";
import styles from "./reviews.module.scss";
import styles2 from "./reviewDetail.module.scss";
import LoadingIcon from "@/components/loadingIcon";

import { DialogTitle, Typography } from "@mui/material";
import { MouseEvent, useState } from "react";
import { anonymousData } from "@/common-components-src/api/reviews/review.interface";
import { handleDeleteComment } from "@/common-components-src/api/reviews/review.api";
import { Button, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import UKToast from "@/components/UKToast/index";
import UKDialog from "@/components/UKDialog";
import MoreIcon from "@/assets/icons/review-more.svg";
import { sendClickTrack as reviewDetailSendClickTrack } from "@/tracks/25347";
import { useTranslation } from "@/i18n/client";

const typographyStyle = {
  fontSize: "14px",
  lineHeight: "20px",
  padding: "5px 12px",
  margin:'4px',
  cursor: "pointer",
  minWidth: "148px",
  whiteSpce: "nowrap",
};

interface Props {
  anonymous: boolean;
  params?: any;
  pageType?: string;
  expConfig?: any;
  onRefresh?: () => void;
  onDeleteCallback?: () => void;
  onAnonymous?: (is: boolean, data: anonymousData) => void;
}
export default function MenuOpts({
  anonymous,
  params,
  pageType,
  expConfig,
  onRefresh,
  onAnonymous,
  onDeleteCallback,
}: Props) {

  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { skuId, commentId } = params || {};
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget);
    switch (pageType) {
      case "reviewDetail":
        reviewDetailSendClickTrack.Evaluate_CommentDetail_Card_Btn({ button_name: "3", commentId: `${commentId}` || "-100", skuid: `${skuId}` || "-100" })
        break;
      default:
        break;
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const onConfirmDelete = async () => {
    setIsLoading(true);
    const { skuId, commentId } = params;
    const res: any = await handleDeleteComment({
      skuId,
      commentId,
    });
    if (res && res.success) {
      if (res?.data?.deleteResult) {
        setDialogOpen(false);
        onDeleteCallback?.();
        UKToast.show({
          icon: "success",
          content: t("common.message.deleteSuccessful"),
        });
      } else {
        UKToast.show({
          icon: "error",
          content: t("common.message.deleteFailed"),
        });
      }
      handlePopoverClose();
      onRefresh?.();
      setIsLoading(false);
    } else {
      setIsLoading(false);
      UKToast.show({
        icon: "error",
        content: res.msg || t("common.message.deleteFailed"),
      });
    }
  };
  const onOpenDeleteDialog = () => {
    setDialogOpen(true);
    handlePopoverClose();
  };
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? "simple-popover" : "";
  return (
    <>
      <div className={cn(styles.btn, styles2.btn)} aria-describedby={id} onClick={handleClick}>
        <MoreIcon className={cn(styles.moreIcon, styles.mar, styles2.moreIcon, styles2.mar)}></MoreIcon>
      </div>
      <IntlPopover id={id} open={popoverOpen} anchorEl={anchorEl} onClose={handlePopoverClose}>
        <Typography sx={typographyStyle} className="report-block"
          exptag={expConfig?.delete?.expTag}
          data-exptag-json-param={JSON.stringify(expConfig?.delete?.data)}
          data-exptag-config={expConfig?.delete?.config}
          onClick={() => {
            switch (pageType) {
              case "reviewDetail":
                reviewDetailSendClickTrack.Evaluate_CommentDetail_More_Layer({ title: "2", commentId: `${commentId}` || "-100", skuid: `${skuId}` || "-100" })
                break;

              default:
                break;
            }
            onOpenDeleteDialog();
          }}
        >
          {t("common.btnText.delete")}
        </Typography>
      </IntlPopover>

      <UKDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        showCloseBtn={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ zIndex: 2300 }}
      >
        <DialogTitle />
        <DialogContent style={{ paddingTop: "20px" }}>
          <DialogContentText id="alert-dialog-description">
            {t("review.deleteConfirm")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} variant="outlined">
            {t("common.btnText.cancel")}
          </Button>
          <Button
            disabled={isLoading}
            startIcon={isLoading ? <LoadingIcon /> : null}
            onClick={onConfirmDelete}
            autoFocus
            variant="contained"
          >
            {t("common.btnText.delete")}
          </Button>
        </DialogActions>
      </UKDialog>
    </>
  );
}
